<nb-card class="container">
  <nb-card-body>
    <ng2-smart-table [settings]="settings"
                     [source]="source"
                     (userRowSelect)="select($event)"
    >
    </ng2-smart-table>
  </nb-card-body>
</nb-card>
